import { Component } from '@angular/core';
import {
    changeDataProject,
    currentDataProject,
    DATA_PROJECTS,
    DataProjectKey,
    hasDataProjectParam,
} from 'src/app/services/data-project/models/data-project.model';
import { NavbarService } from 'src/app/services/navbar/navbar.service';

/**
 * Developer-mode dropdown to switch the BigQuery data project.
 *
 * Visible when developer mode is active (version clicked 5×) or a data-project selection is
 * already present in the URL — the latter keeps the dropdown visible across the reload that
 * a selection triggers.
 */
@Component({
    selector: 'app-data-project-switcher',
    templateUrl: './data-project-switcher.component.html',
    styleUrls: ['./data-project-switcher.component.scss'],
})
export class DataProjectSwitcherComponent {
    readonly projects = DATA_PROJECTS;
    selectedKey: DataProjectKey = currentDataProject().key;

    constructor(private navbar: NavbarService) {}

    get showSwitcher(): boolean {
        return this.navbar.showDevDashboards || hasDataProjectParam();
    }

    onChange(key: DataProjectKey): void {
        if (key !== currentDataProject().key) {
            changeDataProject(key);
        }
    }
}
